// NotFound.jsx or NotFound.tsx
import { Link } from 'react-router-dom'; // Use Next.js Link or your router's Link if needed

export default function NotFound() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full text-center">
        {/* 404 Text */}
        <h1 className="text-9xl font-bold text-indigo-600 tracking-tighter">
          404
        </h1>
        
        {/* Message */}
        <p className="mt-6 text-2xl font-semibold text-gray-900">
          Oops! Page not found
        </p>
        <p className="mt-4 text-lg text-gray-600">
          Sorry, we couldn't find the page you're looking for. It might have been moved or deleted.
        </p>

        {/* Optional illustration or icon */}
        <div className="mt-10">
          <svg
            className="mx-auto h-40 w-40 text-indigo-200"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>

        {/* Action Buttons */}
        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-indigo-600 hover:bg-indigo-700 transition duration-200"
          >
            Go Back Home
          </Link>
         
        </div>
      </div>

      {/* Optional footer note */}
      <p className="mt-12 text-sm text-gray-500">
        If you think this is a mistake, please contact support.
      </p>
    </div>
  );
}